<template>
  <Teleport to="body">
    <TransitionGroup name="toast" tag="ul" class="toaster-wrapper">
      <li
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :class="['toast', toast.type]"
      >
        <AppIcon :name="getIconName(toast.type)" size="body-xl" />
        <div class="column gap-1">
          <p class="body m font-medium">{{ toast.title }}</p>
          <p class="body s font-regular">{{ toast.body }}</p>
        </div>
        <AppIcon
          id="close_icon"
          name="X"
          :onClick="() => toastStore.removeToast(toast.id)"
          size="body-xl"
          class-name="clickable"
        />
      </li>
    </TransitionGroup>
  </Teleport>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconName } from '@/models/icon-types';
import { ToastType, useToasterStore } from '@/stores/useToasterStore';

const toastStore = useToasterStore();

function getIconName(type: ToastType): IconName {
  switch (type) {
    case 'info':
      return 'info';
    case 'success':
      return 'circle-check';
    default:
      return 'warning';
  }
}
</script>

<style scoped lang="scss">
.toaster-wrapper {
  position: fixed;
  top: $space-5;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  list-style: none;
  padding: 0;
  margin: 0;
  user-select: none;
  width: 90vw;
  max-width: 90vw;
  overflow: visible;

  * {
    user-select: none;
  }
}

.toast {
  padding: $space-2;
  margin-bottom: $space-1;
  border-radius: $radius-3;
  color: $color-text-white;
  display: flex;
  flex-direction: row;
  gap: $space-2;
  box-shadow: $elevation-3;
  align-items: center;

  & > :first-child {
    align-self: flex-start;
  }

  &.info {
    background-color: $color-information-500;
  }

  &.success {
    background-color: $color-success-500;
  }

  &.warning {
    background-color: $color-warning-500;
  }

  &.error {
    background-color: $color-error-500;
  }
}

#close_icon {
  position: absolute;
  right: $space-2;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
</style>
